<template>
    <div class="form-group custom-select2-container">

        <label for="">{{label}}</label>
        <div :class="{disabled : disabled}" class="inner-addon right-addon">

            <!-- <img v-if="!selected" class="icon" src="/images/iconos/icon-search.svg" alt=""> -->
            <img v-if="selected" @click="clear" class="icon" src="/images/iconos/Icon-Close-dark.svg" alt="">

             <vue-bootstrap-typeahead 
            :data="data"
            @hit="handler"
            :serializer="prop => prop[propName]"
            :placeholder="placeholder"
            :name="name"
            class="custom-search-input form-input-rounded"
            :key="typeaheadKey"
            :minMatchingChars="1"  />
        
        </div>
    </div>
  
</template>

<script>
import VueBootstrapTypeahead from 'vue-bootstrap-typeahead'
export default {
    props : {
        name : { type : String , default : 'typeahead'},
        data : { type : Array },
        selected : { type : [String,Number] },
        propName : { type : String },
        placeholder : { type : String },
        label : { type : String },
        disabled : { type : Boolean },
    },
    components : {
        VueBootstrapTypeahead
    },
    data(){
        return {
            typeaheadKey : 0
        }
    },
    methods : {
        handler(event) {
            this.$emit( "onSelect", { id : event.id } );
            // this.forceUpdate();
        },
        clear(){
            this.$emit( "clear" );
            this.forceUpdate();
        },
        forceUpdate(){
            this.typeaheadKey += 1;  
        }
    }
}
</script>

<style lang="scss">
/* Global styles (not scoped) for vue-bootstrap-typeahead */
.custom-search-input.form-input-rounded input,
.custom-search-input.form-input-rounded .form-control,
.form-input-rounded input,
.form-input-rounded .form-control {
  height: 48px !important;
  padding: 12px 24px !important;
  border: 2px solid #ccc !important;
  border-radius: 100px !important;
  font-size: 1rem !important;
  font-family: inherit !important;
  background-color: white !important;
  width: 100% !important;
  outline: none !important;
  transition: all 0.2s ease !important;
  box-shadow: none !important;
}

.custom-search-input.form-input-rounded input:focus,
.custom-search-input.form-input-rounded .form-control:focus,
.form-input-rounded input:focus,
.form-input-rounded .form-control:focus {
  border-color: #3b82f6 !important;
  box-shadow: 0 0 0 3px rgba(59, 130, 246, 0.1) !important;
}

.custom-search-input.form-input-rounded input:hover,
.custom-search-input.form-input-rounded .form-control:hover,
.form-input-rounded input:hover,
.form-input-rounded .form-control:hover {
  border-color: #9ca3af !important;
}

.custom-search-input.form-input-rounded input::placeholder,
.custom-search-input.form-input-rounded .form-control::placeholder,
.form-input-rounded input::placeholder,
.form-input-rounded .form-control::placeholder {
  color: #9ca3af !important;
}

/* Dropdown styling */
.custom-search-input.form-input-rounded .dropdown-menu,
.custom-search-input.form-input-rounded .vbt-autcomplete-list,
.form-input-rounded .dropdown-menu,
.form-input-rounded .vbt-autcomplete-list {
  border-radius: 8px !important;
  border: 2px solid #e5e7eb !important;
  box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.1) !important;
  margin-top: 4px !important;
  z-index: 1000 !important;
}

.custom-search-input.form-input-rounded .dropdown-item,
.custom-search-input.form-input-rounded .list-group-item,
.form-input-rounded .dropdown-item,
.form-input-rounded .list-group-item {
  padding: 8px 16px !important;
  font-size: 0.875rem !important;
  color: #374151 !important;
  border: none !important;
  cursor: pointer !important;
}

.custom-search-input.form-input-rounded .dropdown-item:hover,
.custom-search-input.form-input-rounded .list-group-item:hover,
.form-input-rounded .dropdown-item:hover,
.form-input-rounded .list-group-item:hover {
  background-color: #f3f4f6 !important;
  color: #1f2937 !important;
}

.custom-search-input.form-input-rounded .dropdown-item.active,
.custom-search-input.form-input-rounded .list-group-item.active,
.form-input-rounded .dropdown-item.active,
.form-input-rounded .list-group-item.active {
  background-color: #3b82f6 !important;
  color: white !important;
}
</style>

<style scoped lang="scss">
.custom-search-input {
    width: 100%;
    ::placeholder {
            color: lightgray;
    }
}

.disabled {
     opacity: 0.3;
    cursor: default;
    pointer-events: none;
}
</style>